const navigationBlocks = document.querySelectorAll('.block-navigation');

const openEvent = new Event('navigation-search-opened');
const closeEvent = new Event('navigation-search-closed');

const translateButtons = document.querySelectorAll(
	'.block-navigation-translate-button__button'
);

const toggleTranslate = (e) => {
	const currentTranslateButton = e.currentTarget;

	const currentNavigationBlock =
		currentTranslateButton.closest('.block-navigation');

	if (!currentNavigationBlock) {
		return;
	}

	currentNavigationBlock.classList.toggle('translate-active');

	if (currentNavigationBlock.classList.contains('translate-active')) {
		navigationBlocks.forEach((navigationBlock) => {
			if (navigationBlock === currentNavigationBlock) {
				return;
			}

			navigationBlock.classList.remove('translate-active');
		});
	}

	if (currentNavigationBlock.classList.contains('translate-active')) {
		window.dispatchEvent(openEvent);

		document.addEventListener('keydown', clickOffMenu);
		document.addEventListener('click', clickOffMenu);
	} else {
		window.dispatchEvent(closeEvent);

		document.removeEventListener('keydown', clickOffMenu);
		document.removeEventListener('click', clickOffMenu);
	}
};

const closeTranslate = () => {
	if (0 === translateButtons.length || 0 === navigationBlocks) {
		return;
	}

	navigationBlocks.forEach((navigationBlock) => {
		navigationBlock.classList.remove('translate-active');
	});

	window.dispatchEvent(closeEvent);

	document.removeEventListener('keydown', clickOffMenu);
	document.removeEventListener('click', clickOffMenu);
};

const clickOffMenu = (e) => {
	if (0 === navigationBlocks.length) {
		return;
	}

	let closestDropdown;
	let closestTranslateButton;

	if (e.key === undefined && e.target) {
		closestDropdown = e.target.closest(
			'.block-navigation-translate-button__languages'
		);
		closestTranslateButton = e.target.closest(
			'.block-navigation-translate-button__button'
		);
	}

	if (e.key && e.key !== 'Escape') {
		return;
	}

	if (
		closestDropdown?.contains(e.target) ||
		closestTranslateButton?.contains(e.target)
	) {
		return;
	}

	navigationBlocks.forEach((navigationBlock) => {
		if (navigationBlock.classList.contains('translate-active')) {
			navigationBlock.classList.remove('translate-active');

			document.removeEventListener('keydown', clickOffMenu);
			document.removeEventListener('click', clickOffMenu);
		}
	});

	window.dispatchEvent(closeEvent);
};

if (translateButtons.length > 0) {
	translateButtons.forEach((translateButton) => {
		translateButton.addEventListener('click', toggleTranslate);
	});
}

window.addEventListener('navigation-opened', closeTranslate);
window.addEventListener('navigation-submenu-opened', closeTranslate);
